/*global Modernizr, link_icons, clicked_link:true, setup_tla_lottie */
/*jslint browser:true */

(function() {
  'use strict';

  // Select the node that will be observed for mutations
  const targetNode = document.getElementById('page-content');

  // Options for the observer (which mutations to observe)
  const config = { childList: true, subtree: true };

  // Callback function to execute when mutations are observed
  const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0 && mutation.addedNodes[0] instanceof HTMLElement) {
        if(mutation.addedNodes[0].nodeName.toLowerCase() === 'a') {
          tec_process_links([mutation.addedNodes[0]]);
        } else if(mutation.addedNodes[0].querySelectorAll('a').length > 0) {
          tec_process_links(mutation.addedNodes[0].querySelectorAll('a'));
        }
      }
    }
  };

  // Create an observer instance linked to the callback function
  const observer = new MutationObserver(callback);

  // Start observing the target node for configured mutations
  if(targetNode) {
    observer.observe(targetNode, config);
  }

  tec_process_links(document.querySelectorAll('a'));
}());

function tec_process_links(links) {
  'use strict';

  links.forEach((link) => {
    var map_container = link.closest(".map-wrapper");

    if(map_container) {
      return;
    }

    if(link.nodeName.toLowerCase() === 'a' && !link.classList.contains('js-link-processed') && !link.closest('#wpadminbar')) {
      link.classList.add('disable-transition');
      link.classList.add('js-link-processed');

      var link_type = 'base',
          new_window = false,
          button_icon;

      var ignored_file_types = [
        'php',
        'html',
        'htm',
        'aspx',
        'asp',
        'cfm'
      ];

      if((link.pathname.slice(-4, -3) === '.' || link.pathname.slice(-5, -4) === '.') && !ignored_file_types.includes(link.pathname.slice(-3)) && !ignored_file_types.includes(link.pathname.slice(-4)) && link.protocol !== 'mailto:') {
        link_type = 'download';
      }

      if(link.hasAttribute('target') && link.getAttribute('target') === '_blank') {
        new_window = true;
        link_type = 'external';
      }

      if(!link.classList.contains('no-icon')) {
        if(link.classList.contains('editor-button') || link.classList.contains('download')) {
          link.innerHTML = '<span class="button-text">' + link.textContent + '</span><span class="icon lottie" data-json="button"></span>';
          link.classList.add('tla-button');
          link.classList.remove('button');
          link.classList.remove('editor-button');
          setup_tla_lottie(link.querySelector('.lottie'));
        }

        if(link.classList.contains('download')) {
          link.classList.add('small');
          link_type = 'download';
        }

        if(link_type !== 'base' && !link.classList.contains('icon-only')) {
          var wrapper = link.querySelector('.button-wrapper');

          if(!wrapper) {
            wrapper = link;
          }

          button_icon = link.querySelector('.icon');

          if(!button_icon) {
            button_icon = link.querySelector('svg');

            if(!link.classList.contains('tla-button')) {
              link_type = link_type + '_inline';
            }
          }

          if(button_icon) {
            button_icon.remove();
          }

          wrapper.insertAdjacentHTML('beforeend', link_icons[link_type]);
        }
      }

      if(new_window) {
        link.insertAdjacentHTML('afterbegin', '<i class="screen-reader-text">link opens in a new window</i>');
      }

      // Trigger a reflow, flushing the CSS changes before we turn transitions back on
      link.offsetHeight;
      link.classList.remove('disable-transition');
    }
  });
}
